<template>
<div>
  <b-card header="Importações">
    <Grid name="filterGridImports" ref="filterGridImports" v-bind:url="url" v-bind:columns="columns" :pageable='true'  :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
export default {
  name: 'Imports',
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'file_rows': {
          type: 'number'
        },
        'imported_rows': {
          type: 'number'
        }
      },
      url: 'import/batches',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        width: '160px',
        field: 'id',
        title: 'ID Importação'
      }, {
        field: 'files_count',
        title: 'Nº Tabelas',
        width: '200px'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'tables.import-results',
        params: {
          id: item.id
        }
      })
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-search"></i> ver</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// imports.vue?7a887cec